import React, { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../lib/api";

const StoreContext = createContext(null);
export const useStore = () => useContext(StoreContext);

const DEFAULT_SETTINGS = {
  store_name: "Aadvan Dry Fruits",
  address: "Civil Lines, Sitapur, Uttar Pradesh 261001",
  phone: "+91 90000 00000",
  whatsapp: "919000000000",
  email: "care@aadvan.in",
  instagram: "https://instagram.com",
  facebook: "https://facebook.com",
};

const load = (key, fallback) => {
  try {
    const v = localStorage.getItem(key);
    return v ? JSON.parse(v) : fallback;
  } catch {
    return fallback;
  }
};

export const StoreProvider = ({ children }) => {
  const [cart, setCart] = useState(() => load("aadvan_cart", []));
  const [wishlist, setWishlist] = useState(() => load("aadvan_wishlist", []));
  const [isCartOpen, setCartOpen] = useState(false);
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);

  useEffect(() => {
    api.get("/settings").then((r) => setSettings({ ...DEFAULT_SETTINGS, ...r.data })).catch(() => {});
  }, []);

  useEffect(() => localStorage.setItem("aadvan_cart", JSON.stringify(cart)), [cart]);
  useEffect(() => localStorage.setItem("aadvan_wishlist", JSON.stringify(wishlist)), [wishlist]);

  const cartKey = (i) => `${i.product_id}__${i.variant}`;

  const addToCart = (item, openDrawer = true) => {
    setCart((prev) => {
      const idx = prev.findIndex((p) => cartKey(p) === cartKey(item));
      if (idx > -1) {
        const next = [...prev];
        next[idx] = { ...next[idx], qty: next[idx].qty + item.qty };
        return next;
      }
      return [...prev, item];
    });
    toast.success(`${item.name} (${item.variant}) added to cart`);
    if (openDrawer) setCartOpen(true);
  };

  const updateQty = (key, qty) => {
    if (qty < 1) return;
    setCart((prev) => prev.map((p) => (cartKey(p) === key ? { ...p, qty } : p)));
  };

  const removeFromCart = (key) => setCart((prev) => prev.filter((p) => cartKey(p) !== key));
  const clearCart = () => setCart([]);

  const toggleWishlist = (slug, name) => {
    setWishlist((prev) => {
      if (prev.includes(slug)) {
        toast(`${name} removed from wishlist`);
        return prev.filter((s) => s !== slug);
      }
      toast.success(`${name} added to wishlist`);
      return [...prev, slug];
    });
  };

  const cartCount = cart.reduce((s, i) => s + i.qty, 0);
  const cartSubtotal = cart.reduce((s, i) => s + i.price * i.qty, 0);

  return (
    <StoreContext.Provider
      value={{
        cart, wishlist, isCartOpen, setCartOpen, settings,
        addToCart, updateQty, removeFromCart, clearCart,
        toggleWishlist, cartCount, cartSubtotal, cartKey,
      }}
    >
      {children}
    </StoreContext.Provider>
  );
};
